import { qnRed } from '../themes/_palette';

export const MuiFormLabel = {
    styleOverrides: {
        asterisk: {
            color: qnRed[900]
        }
    }
}
